<div class="checkbox-group" [ngClass]="orientation" *ngIf="lineSize === 0" [attr.disabled]="notEnabled?'':null">
    <div class="checkbox" *ngFor="let so of options">
        <aa-checkbox [toTranslate]="toTranslate" [option]="so"> </aa-checkbox>
    </div>
</div>
<div class="checkbox-group" *ngIf="lineSize !== 0" [attr.disabled]="notEnabled?'':null">
    <table>
        <tr *ngFor="let line of lines; index as i">
            <td *ngFor="let so of options.slice(i * lineSize, (i + 1) * lineSize)">
                <aa-checkbox [toTranslate]="toTranslate" [option]="so"> </aa-checkbox>
            </td>
        </tr>
    </table>
</div>
